<template>
    <div class="element CheckboxField WidgetField">
        <div class="Checkbox_container">
            <div class="Checkbox_element">
                <input type="checkbox" id="checkbox1" class="checkbox" />
                <label for="checkbox1" class="label">
                    <span class="title">
                        <span class="abbreviation" style="--bgcolor: #8fe6ad">ATS</span>
                        <span class="title">Applicant Tracking System</span>
                    </span>
                </label>
            </div>
            <div class="Checkbox_element">
                <input type="checkbox" id="checkbox2" class="checkbox" />
                <label for="checkbox2" class="label">
                    <span class="title">
                        <span class="abbreviation" style="--bgcolor: #8fe6ad">ATS</span>
                        <span class="title">Applicant Tracking System</span>
                    </span>
                </label>
            </div>
            <div class="Checkbox_element">
                <input type="checkbox" id="checkbox3" class="checkbox" />
                <label for="checkbox3" class="label">
                    <span class="title">
                        <span class="abbreviation" style="--bgcolor: #8fe6ad">ATS</span>
                        <span class="title">Applicant Tracking System</span>
                    </span>
                </label>
            </div>
            <div class="Checkbox_element">
                <input type="checkbox" id="checkbox4" class="checkbox" />
                <label for="checkbox4" class="label">
                    <span class="title">
                        <span class="abbreviation" style="--bgcolor: #8fe6ad">ATS</span>
                        <span class="title">Applicant Tracking System</span>
                    </span>
                </label>
            </div>
        </div>
    </div>
</template>

<style>
</style>

<script>
import { ref, watch, reactive, inject } from "vue";

// Our form helpers
import useFormValidation from "./_validation";
import { propDefaults } from "./_props";

// Our helpers
import trans from "helpers/_translation";
import { mergeDeep } from "helpers/_objects";

import { portalStore } from "store/portal";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
    },
    setup(props) {
        return {
        };
    },
}
</script>